import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const blogsRef = collection(db, "blogs");
        const q = query(blogsRef, where("slug", "==", slug));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();
          setBlog({
            id: snapshot.docs[0].id,
            ...data,
            date: data.date?.toDate().toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }),
          });
        }
      } catch (err) {
        console.error("Error fetching blog:", err);
      }
    };

    fetchBlog();
  }, [slug]);

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading blog...
      </div>
    );
  }

  return (
    <div
      className="min-h-screen py-16 px-4 md:px-20"
      style={{ backgroundColor: "var(--bg-1)", color: "var(--brand-dark)" }}
    >
      <div className="container-custom max-w-4xl mx-auto">
        {/* Blog Cover Image */}
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-80 object-cover rounded-2xl mb-8"
        />

        {/* Title */}
        <h1 className="text-4xl font-bold mb-4">{blog.title}</h1>

        {/* Full content */}
        {blog.content ? (
          <div className="text-lg text-gray-700 leading-relaxed mb-10">
            {blog.content.split("\n").map((line, i) => (
              <p key={i} className="mb-4">{line}</p>
            ))}
          </div>
        ) : (
          <p className="text-lg text-gray-700 mb-10">{blog.excerpt}</p> // fallback
        )}

        {/* Back to Blog */}
        <Link
          to="/blog"
          className="text-brand-gold font-semibold hover:underline"
        >
          ← Back to Blog
        </Link>
      </div>
    </div>
  );
};

export default BlogDetail;